import React from 'react';
import SignUpForm from '../signup';
import TopPanel from '../toppanel';
import './register.accounts.scss';

export default class RegisterPage extends React.Component {
  componentDidMount() {
    HC_SelectNavItem('li-register-new-accounts');
  }

  render() {
    return (
      <div className="register-page">
        <TopPanel text="Register New Account" licon="fa-bars" onLiconClick={HC_ToggleNavPanel}/>
        <SignUpForm saMode={HC_GetBoolSetting('HC_SA')} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./admins/register.accounts.js